import { action, props } from 'ts-action';
import { SkipHistory } from '../../undo/actions/undo.actions';
import { EcgState } from '../types/ecg-state';

type EditableState = Partial<
  Pick<EcgState, 'duration' | 'recordType' | 'pipeline' | 'holterStripInfo'>
>;

export const clean = action('[Ecg] clean', props<SkipHistory>());

export const loaded = action(
  '[Ecg] loaded',
  props<{ ecg: EcgState } & SkipHistory>(),
);

export const update = action(
  '[Ecg] update',
  props<{ update: EditableState } & SkipHistory>(),
);
